/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrganizationAdminUpdate
 */
export interface OrganizationAdminUpdate {
    /**
     * 
     * @type {string}
     * @memberof OrganizationAdminUpdate
     */
    org_code: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationAdminUpdate
     */
    address: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationAdminUpdate
     */
    company_name: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationAdminUpdate
     */
    join_org_pin?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationAdminUpdate
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationAdminUpdate
     */
    phone_number: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationAdminUpdate
     */
    primary_contact: string;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof OrganizationAdminUpdate
     */
    roles_with_features_custom?: { [key: string]: Array<string>; } | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationAdminUpdate
     */
    organization_azure_id: string;
}

/**
 * Check if a given object implements the OrganizationAdminUpdate interface.
 */
export function instanceOfOrganizationAdminUpdate(value: object): value is OrganizationAdminUpdate {
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('company_name' in value) || value['company_name'] === undefined) return false;
    if (!('phone_number' in value) || value['phone_number'] === undefined) return false;
    if (!('primary_contact' in value) || value['primary_contact'] === undefined) return false;
    if (!('organization_azure_id' in value) || value['organization_azure_id'] === undefined) return false;
    return true;
}

export function OrganizationAdminUpdateFromJSON(json: any): OrganizationAdminUpdate {
    return OrganizationAdminUpdateFromJSONTyped(json, false);
}

export function OrganizationAdminUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationAdminUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'org_code': json['org_code'],
        'address': json['address'],
        'company_name': json['company_name'],
        'join_org_pin': json['join_org_pin'] == null ? undefined : json['join_org_pin'],
        'email': json['email'] == null ? undefined : json['email'],
        'phone_number': json['phone_number'],
        'primary_contact': json['primary_contact'],
        'roles_with_features_custom': json['roles_with_features_custom'] == null ? undefined : json['roles_with_features_custom'],
        'organization_azure_id': json['organization_azure_id'],
    };
}

export function OrganizationAdminUpdateToJSON(json: any): OrganizationAdminUpdate {
    return OrganizationAdminUpdateToJSONTyped(json, false);
}

export function OrganizationAdminUpdateToJSONTyped(value?: OrganizationAdminUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_code': value['org_code'],
        'address': value['address'],
        'company_name': value['company_name'],
        'join_org_pin': value['join_org_pin'],
        'email': value['email'],
        'phone_number': value['phone_number'],
        'primary_contact': value['primary_contact'],
        'roles_with_features_custom': value['roles_with_features_custom'],
        'organization_azure_id': value['organization_azure_id'],
    };
}

